// SK Voice console — MONOCHROME palette, values taken verbatim from the design
// handoff HTML (:root and [data-theme="dark"]). The console is deliberately
// black & white: there is no brand hue. Semantic keys (accent/info/success/…)
// are kept for component compatibility but resolve to ink shades — state is
// shown via ink tone + fills + dots, never color.

export const LightColors = {
  // Surfaces
  paper:   '#ffffff',
  paper2:  '#f6f6f4',
  paper3:  '#ededea',
  card:    '#ffffff',

  // Ink (text)
  ink:     '#0b0b0c',
  ink2:    '#3a3a3d',
  ink3:    '#76767b',
  ink4:    '#a6a6ac',

  // Lines
  line:        '#e6e6e3',
  lineStrong:  '#d3d3ce',

  // Accent = ink (monochrome). onAccent = paper.
  accent:      '#0b0b0c',
  accentInk:   '#0b0b0c',
  accentSoft:  '#f6f6f4',
  accentLine:  '#d3d3ce',
  onAccent:    '#ffffff',

  // Semantic sets → mapped to ink shades (no hue in this design).
  info:      '#0b0b0c', infoSoft:  '#f6f6f4', infoLine:  '#d3d3ce',
  success:   '#0b0b0c', successSoft: '#f6f6f4', successLine: '#d3d3ce',
  warn:      '#0b0b0c', warnSoft:  '#f6f6f4', warnLine:  '#d3d3ce',
  danger:    '#0b0b0c', dangerSoft: '#f6f6f4', dangerLine: '#d3d3ce',
  neutral:   '#76767b', neutralSoft: '#f6f6f4', neutralLine: '#d3d3ce',

  // The one hue exception: call-OUTCOME dots read faster in color (green/amber/red).
  // Tuned for the light card (#fff); dark set is brighter to hold on the dark card.
  outcomeOk:   '#1d9e5f',
  outcomeMiss: '#d68a00',
  outcomeDrop: '#d6453f',

  white: '#ffffff',
  black: '#000000',
  transparent: 'transparent',
};

export const DarkColors = {
  paper:   '#0a0a0b',
  paper2:  '#141416',
  paper3:  '#1d1d20',
  card:    '#141416',

  ink:     '#fafafa',
  ink2:    '#d2d2d4',
  ink3:    '#9a9aa0',
  ink4:    '#65656b',

  line:        '#282829',
  lineStrong:  '#3a3a3d',

  accent:      '#fafafa',
  accentInk:   '#fafafa',
  accentSoft:  '#141416',
  accentLine:  '#3a3a3d',
  onAccent:    '#0a0a0b',

  info:      '#fafafa', infoSoft:  '#141416', infoLine:  '#3a3a3d',
  success:   '#fafafa', successSoft: '#141416', successLine: '#3a3a3d',
  warn:      '#fafafa', warnSoft:  '#141416', warnLine:  '#3a3a3d',
  danger:    '#fafafa', dangerSoft: '#141416', dangerLine: '#3a3a3d',
  neutral:   '#9a9aa0', neutralSoft: '#141416', neutralLine: '#3a3a3d',

  // Brighter on the dark card so the 7px outcome dots stay legible.
  outcomeOk:   '#35ce88',
  outcomeMiss: '#edb44a',
  outcomeDrop: '#f26a63',

  white: '#ffffff',
  black: '#000000',
  transparent: 'transparent',
};

export type ColorScheme = typeof LightColors;
